// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"horizontalBar__wrapper___SfYVB","footer":"horizontalBar__footer___XX7o1","header":"horizontalBar__header___QQsg3"};